export const TOGGLE_EDIT_ACCESS_ROLE_DIALOG_OPEN =
  "TOGGLE_EDIT_ACCESS_ROLE_DIALOG_OPEN";
export const TOGGLE_EDIT_ACCESS_ROLE_DIALOG_CLOSE =
  "TOGGLE_EDIT_ACCESS_ROLE_DIALOG_CLOSE";
